<template>
  <div class="SkuPicker">
    <el-dialog
      :visible.sync="visible"
      center
      :show-close="false"
      :before-close="beforeClose"
      custom-class="picker-modal"
    >
      <div class="header" @click="beforeClose">
        <i class="icon iconfont">&#xe65d;</i>
      </div>
      <div class="modal-wrap">
        <div class="imgBox">
          <img :src="imgUrl" alt />
          <!-- <img class="soldOut" :src="require('@assets/images/allGone.png')" alt v-if="goods.bizStock === 0" /> -->
          <!-- <Sticker :imgList="goods.stickerImgList" /> -->
          <!-- 爆炸贴图片 -->
          <Sticker :imgList="stickerImgList" />
        </div>
        <div class="main-content">
          <h3>
            <i
              v-for="(tag, index) in myChoose.tags"
              :key="index"
              :style="{ fontStyle: 'normal'}"
            >
              <SingleTag :show="tag.mktFrontType === 9005" :datas="tag" />
            </i>
            {{ goods.goodsName }}
          </h3>
          <!-- <img
            :src="tagInfo.mktIcon || ''"
            v-if="tagInfo.mktIcon"
            alt=""
            class="tag"
          /> -->
          <!-- <img
            v-for="(tag, index) in myChoose.tags"
            v-show="tag.type === 1 && tag.mktIcon"
            :key="index"
            class="tag"
            :src="tag.mktIcon"
          /> -->
          <div v-if="myChoose.tags">
            <span
              v-for="(tag, index) in myChoose.tags"
              :key="index"
              :style="{ display: 'inline-block', margin: '8px 4px 13px 0' }"
            >
              <SingleTag :show="tag.type === 1 && tag.mktIcon" :datas="tag" />
            </span>
          </div>
          <div class="price-row row">
            <span>{{TLang('售价','my')}}</span>
            <img
              :src="union_icon || require('./../../assets/images/fudou.png')"
              alt
              class="fudou"
            />
            <FormatPrice
              :price="(myChoose.promPrice || myChoose.price || 0) * union_scale"
              size="m"
            />
            <div class="line-price-box" v-if="myChoose.promPrice">
              <img
                :src="union_icon || require('@assets/images/fudou.png')"
                alt=""
                class="fudou2"
              />
              <span class="line-price-num">{{
                (
                  (myChoose.salePrice || myChoose.price || 0) * union_scale
                ).toFixed(2)
              }}</span>
            </div>
          </div>
          <div class="discountPriceWrap">
            <DiscountPrice
              :discountPrice="myChoose.discountPrice"
              :discount="myChoose.discount"
              :discountTagShow="myChoose.discountTagShow"
              :mktTagShow="myChoose.mktTagShow"
            />
          </div>
          <div
            v-if="goods && goods.goodsSpecList && goods.goodsSpecList.length"
            class="spec-row row"
          >
            <span>{{TLang('规格','my')}}：</span>
            <ul>
              <li
                v-for="spec in goods.goodsSpecList"
                :key="spec.goodsId"
                :class="{
                  active: spec.goodsId === myChoose.goodsId,
                  disable: spec.gray,
                }"
                @click="checkoutChoose(spec)"
              >
              <!-- 英文 -->
                <el-tooltip
                  v-if="CookiesOne==='en-US'"
                  effect="light"
                  content="Sold out"
                  placement="top"
                  :disabled="!spec.gray"
                  popper-class="goods-tip"
                  :tabindex="spec.goodsId"
                >
                  <p>{{ spec.specValue1 || spec.specName }}</p>
                </el-tooltip>
                <!-- 中文 -->
                <el-tooltip
                  v-if="CookiesOne!=='en-US'"
                  effect="light"
                  :content="TLang('该商品已售罄', 'goods')"
                  placement="top"
                  :disabled="!spec.gray"
                  popper-class="goods-tip"
                  :tabindex="spec.goodsId"
                >
                  <p>{{ spec.specValue1 || spec.specName }}</p>
                </el-tooltip>
              </li>
            </ul>
          </div>
          <efficiency-date :data="myChoose" type="picker"></efficiency-date>
          <!-- <div v-if="myChoose.advanceSale" class="delivery">
            <img
              :src="
                union_isBilingual || CookiesOne && CookiesOne == 'en-US'
                  ? require('../../assets/images/productDetail/pre-tag-en.png')
                  : require('../../assets/images/productDetail/pre-tag.png')
              "
              alt=""
              :class="['pre-tag']"
              :style="{ marginLeft: union_isBilingual ? '-10px' : '' }"
            />
            <span>
              {{
                `现在下单，${new Date(myChoose.sendGoodsTimeStart)
                  .toLocaleDateString()
                  .replace(/\//g, "-")}起开始发货`
              }}
            </span>
          </div>
          <div
            v-else-if="
              myChoose.deliveryWay === '3' &&
              !myChoose.advanceSale &&
              myChoose.cutOffTimeStr
            "
            class="delivery"
          >
            <img
              :src="require('../../assets/images/productDetail/trunk.png')"
              alt=""
            />
            <span>
              {{
                new Date().getHours() < myChoose.cutOffTimeStr.split(":")[0]
                  ? `${myChoose.cutOffTimeStr}前（含${myChoose.cutOffTimeStr})下单，可选今日发货`
                  : `${myChoose.cutOffTimeStr}后下单，可选次日起发货`
              }}
            </span>
          </div> -->
          <div v-if="visible" class="count-row row">
            <span>{{ TLang('数量','my') }}</span>
            <Stepper
              :buyLimit="myChoose.buyLimit"
              :buyMin="myChoose.buyMin"
              :onChange="onStepChange"
              :stockNum="myChoose.availableStockNum"
              :bizStock="myChoose.bizStock"
              :defaultValue="myChoose.buyMin"
              :isCart="false"
            />
          </div>
          <div v-if="!myChoose.gray" class="btns-row">
            <div
              @click="
                onAdd(
                  { ...myChoose, num, goodsName: goods.goodsName },
                  { goods }
                )
              "
            >
              {{ TLang('加入购物车','my') }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Stepper from "./../../views/product/detail/StepperRow";
import Sticker from "@components/sticker";
import SingleTag from "@components/singleTag";
import EfficiencyDate from "@components/efficiencyDate";
import { getActivityTag } from "@fetch/shopping";
import DiscountPrice from "./../../views/lifeIndex/DiscountPrice";
import Cookies from 'js-cookie';
export default {
  name: "Skupicker",
  components: { Stepper, Sticker, EfficiencyDate, DiscountPrice, SingleTag },
  props: {
    visible: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    goods: {
      type: Object,
      default: function () {
        return {};
      },
    },
    onClose: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
    onAdd: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
    stockNum: Number,
  },
  data() {
    return {
      myChoose: {},
      num: 1,
      tagInfo: {},
      stickerImgList: [],
      promPrice: 0,
      bizStock: null, // 活动业务库存 为0时展示：抢光了
      imgUrl: this.goods.imgGuide || this.goods.goodsImage,
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  watch: {
    goods: function (props) {
      if (props.goodsSpecList && props.goodsSpecList.length) {
        props.goodsSpecList.map((sku) => {
          if (sku.goodsId === props.goodsId) {
            this.myChoose = sku;
            this.imgUrl = sku.imgUrl;
            // console.log(this.myChoose, "choose");
            this.getTag(sku);
          }
        });
      }
    },
  },
  mounted() {},
  methods: {
    beforeClose() {
      this.onClose();
    },
    onStepChange(val) {
      this.num = val;
    },
    checkoutChoose(sku) {
      this.myChoose = sku;
      this.imgUrl = sku.imgUrl;
      //console.log(sku, "sku");
      // this.getTag(sku);
    },
    // 获取sku对应的标签信息
    getTag(sku) {
      getActivityTag({
        channel: 2,
        goodsList: [{ categoryId: sku.categoryId, goodsId: sku.goodsId }],
      }).then((res) => {
        // 新品的标签加购不需要展示,需要展示特价抢购和满减的标签
        //type 1特价抢购  满减   2爆炸贴    3新品
        //mktFrontType  1001 特价 1004 抢购 2001 满减 9001 新品
        this.tagInfo.tags = res[0].tags.filter((item) => item.type === 1);
        // 爆炸贴数据
        this.stickerImgList = res[0].tags.filter((item) => item.type === 2);
        if (res[0].promPrice) {
          this.salePrice = res[0].salePrice;
          this.promPrice = res[0].promPrice;
        } else {
          this.salePrice = 0;
          this.promPrice = 0;
        }
        if (res[0].bizStock >= 0) {
          this.bizStock = res[0].bizStock;
        }
      });
    },
  },
};
</script>

<style lang="less">
.SkuPicker {
  .picker-modal {
    margin-top: 50vh !important;
    transform: translateY(-50%);
  }
  .el-dialog__header {
    padding: 0;
  }
  .header {
    float: right;
    width: 32px;
    height: 32px;
    margin-top: -25px;
    margin-right: -20px;
    i {
      font-size: 30px;
      color: #333;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .modal-wrap {
    display: flex;
    margin-top: 15px;
    .imgBox {
      position: relative;
      img {
        width: 168px;
        height: 168px;
      }
      .soldOut {
        width: 53%;
        height: 53%;
        position: absolute;
        top: 23.5%;
        left: 23.5%;
        z-index: 10;
      }
    }
    .main-content {
      margin-left: 46px;
      .row {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        span {
          color: #999;
          font-size: 12px;
        }
      }
      h3 {
        font-size: 16px;
        color: #333;
        margin-bottom: 30px;
        max-width: 400px;
      }
      .price-row {
        .fudou {
          width: 16px;
          height: 16px;
          margin-left: 16px;
          margin-right: 4px;
        }
      }
      .spec-row {
        white-space: nowrap;
        margin-bottom: 0;
        ul {
          margin-right: 16px;
          display: flex;
          flex-wrap: wrap;
          margin-left: 16px;
          li {
            color: #333;
            height: 32px;
            line-height: 32px;
            padding: 0 12px;
            text-align: center;
            border: 1px solid #e5e5e5;
            margin-right: 12px;
            margin-bottom: 10px;
          }
          li.active {
            border: 2px solid #3d96e2;
            position: relative;
            &::after {
              position: absolute;
              bottom: 0;
              right: 0;
              content: "";
              width: 0;
              height: 0;
              border-bottom: 10px solid #3d96e2;
              border-left: 10px solid transparent;
            }
          }
          li.disable {
            background: rgba(51, 51, 51, 0.03);
            border: 1px solid rgba(204, 204, 204, 1);
            border-style: dashed;
            color: #666;
          }
          li.disable.active {
            border: 2px solid rgba(61, 150, 226, 1);
            background: rgba(51, 51, 51, 0.03);
            color: #666;
          }
        }
      }
      .count-row {
        /deep/ .stepper-row {
          .stepper {
            margin-left: 16px;
            .count {
              width: 32px;
              height: 32px;
              line-height: 32px;
            }
            input {
              height: 32px;
              line-height: 32px;
            }
          }
        }
      }
      .delivery {
        line-height: 30px;
        margin-left: 42px;
        margin-bottom: 10px;
        img {
          width: 18px;
          height: 18px;
          vertical-align: middle;
        }
        img.pre-tag {
          width: 36px;
          height: 20px;
        }
        span {
          font-size: 14px;
          color: #666;
        }
      }
      .btns-row {
        div {
          width: 165px;
          height: 40px;
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          border-radius: 4px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          font-weight: bold;
        }
      }
      .line-price-box {
        margin-top: 4px;
        margin-left: 10px;
        position: relative;
        .fudou2 {
          width: 8px;
          height: 8px;
          margin-top: 0;
          vertical-align: middle;
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
          opacity: 0.7;
        }
        .line-price-num {
          font-size: 12px;
          color: #999999;
        }
        &:after {
          content: "";
          width: 103%;
          height: 1px;
          position: absolute;
          left: -1px;
          top: 11px;
          background-color: #999999;
        }
      }
    }
    .tag {
      // display: block;
      width: 34px;
      height: 16px;
      margin: 8px 6px 13px 0;
    }
  }
  &:hover {
    cursor: pointer;
  }
  .discountPriceWrap {
    margin: -20px 0 20px 40px;
  }
}
</style>
